import React, { Fragment, useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography, Divider, List, ListItem,
    ListItemText, ListItemIcon, Avatar, Link
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';

import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Icon from '@mdi/react';
import {
    mdiBusStop, mdiBookMarker,
} from '@mdi/js';
import eventIcons from '../../utils/eventIcons.js';

import {
    setHighlightedStop, highlightedStopSelector,
    removeHighlightedStop,
} from '../../features/datacenter/historySlice.js';
import { setCenter, setZoom } from '../../features/map/mapSlice';


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: useTheme().transitions.create('transform', {
            duration: useTheme().transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
}));

const TimeLineStopItem = ({ data, track }) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const oneDay = moment(data.stopStartTime).format('D/M/Y') === moment(data.stopEndTime).format('D/M/Y');

    const highlightedStop = useSelector(highlightedStopSelector);
    const thisStopHighlighted = highlightedStop.startIndex === data.startIndex;

    const highlightStopCallback = () => {
        if (thisStopHighlighted) {
            dispatch(removeHighlightedStop());
        } else {
            dispatch(setHighlightedStop({
                startIndex: data.startIndex,
            }))
            dispatch(setCenter({
                lat: track[data.startIndex].lat,
                lng: track[data.startIndex].lng,
            }));
            dispatch(setZoom(17));
        }
    }
    return (
        <Card className={classes.root} style={{ backgroundColor: thisStopHighlighted ? 'Beige' : 'White' }}>
            <CardHeader
                title={
                    <Typography varant="body1">
                        <Link href="#" onClick={highlightStopCallback}>
                            <b><span style={{ color: 'GoldenRod' }}>Stop: </span></b>
                        </Link>
                        {data.stopDuration}
                    </Typography>
                }
                subheader={
                    <Fragment>
                        <Typography variant="subtitle2" color="textSecondary" component="span">
                            <b>Came: </b> {`${moment(data.stopStartTime).format('Do MMM YY hh:mm A')}`}
                        </Typography>
                        <br />
                        <Typography variant="subtitle2" color="textSecondary" component="span">
                            <b>Left: </b> {`${moment(data.stopEndTime).format('Do MMM YY hh:mm A')}`}
                        </Typography>
                        <br />
                        {
                            data.events.length > 0 &&
                            <Typography variant="subtitle2" color="textSecondary" component="span">
                                <b>Events: </b> {data.events.length}
                            </Typography>
                        }

                    </Fragment>
                }
                action={
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        size="large">
                        <ExpandMoreIcon />
                    </IconButton>
                }
                avatar={
                    <Avatar style={{ backgroundColor: 'white' }}>
                        <Icon
                            path={mdiBusStop}
                            title="Stop"
                            size={1}
                            color="GoldenRod"
                        />
                    </Avatar>
                }
            />
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <Divider />
                    <List dense>
                        {
                            track[data.startIndex].address && track[data.startIndex].address.fmtd_addr &&
                            <ListItem>
                                <ListItemIcon>
                                    <Avatar style={{ backgroundColor: 'White' }}>
                                        <Icon
                                            path={mdiBookMarker}
                                            title="Location"
                                            size={0.8}
                                            color="SaddleBrown"
                                        />
                                    </Avatar>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Fragment>
                                            <b>Location: </b>
                                        </Fragment>
                                    }
                                    secondary={
                                        <Fragment>
                                            {track[data.startIndex].address.net_addr}
                                        </Fragment>
                                    }
                                />
                            </ListItem>
                        }
                        {
                            data.events.length > 0 &&
                            <Fragment>
                                {
                                    data.events.map(e =>
                                        <ListItem key={e.event_id}>
                                            <ListItemIcon>
                                                <Avatar style={{ backgroundColor: 'White' }}>
                                                    {eventIcons(e.event_type || e.event_desc)}
                                                </Avatar>
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Fragment>
                                                        <b>{e.event_type || e.event_desc}</b> at {moment(e.event_time).format(oneDay ? 'h:mm A' : 'D/M/Y h:mm A')}
                                                    </Fragment>
                                                }
                                            /*secondary={track[e.routeIndex].address ? track[e.routeIndex].address.fmtd_addr : ''}*/
                                            />
                                        </ListItem>
                                    )
                                }
                            </Fragment>
                        }
                    </List>
                </CardContent>
            </Collapse>
        </Card>
    );
}

export default TimeLineStopItem;